document.addEventListener('DOMContentLoaded', function () {
  initCountdowns();
  initEmailValidation();
  initSoftAccess();
});

function initCountdowns() {
  var countdowns = document.querySelectorAll('[data-fnd-countdown]');

  countdowns.forEach(function (countdown) {
    var targetRaw = countdown.getAttribute('data-target');
    if (!targetRaw) return;

    var targetDate = new Date(targetRaw);
    if (isNaN(targetDate.getTime())) return;

    var daysEl = countdown.querySelector('[data-fnd-countdown-days]');
    var hoursEl = countdown.querySelector('[data-fnd-countdown-hours]');
    var minutesEl = countdown.querySelector('[data-fnd-countdown-minutes]');
    var secondsEl = countdown.querySelector('[data-fnd-countdown-seconds]');

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateCountdown() {
      var now = new Date();
      var diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
}

function initEmailValidation() {
  var forms = document.querySelectorAll('.fendskii-form');

  forms.forEach(function (form) {
    var emailInput = form.querySelector('[data-fnd-email-input]');
    var errorEl = form.querySelector('[data-fnd-email-error]');

    if (!emailInput || !errorEl) return;

    function showError() {
      errorEl.classList.add('is-visible');
    }

    function hideError() {
      errorEl.classList.remove('is-visible');
    }

    emailInput.addEventListener('input', function () {
      if (emailInput.validity.valid) {
        hideError();
      }
    });

    form.addEventListener('submit', function (event) {
      var value = emailInput.value.trim();

      if (!value || !emailInput.validity.valid) {
        event.preventDefault();
        showError();
        emailInput.focus();
        return;
      }

      hideError();
    });
  });
}

function initSoftAccess() {
  var modal = document.querySelector('[data-fnd-soft-access-modal]');
  if (!modal) return;

  var openButtons = document.querySelectorAll('[data-fnd-soft-access-open]');
  var closeButtons = modal.querySelectorAll('[data-fnd-soft-access-close]');
  var form = modal.querySelector('[data-fnd-soft-access-form]');
  var input = modal.querySelector('[data-fnd-soft-access-input]');
  var error = modal.querySelector('[data-fnd-soft-access-error]');

  if (!form || !input || !error) return;

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('fnd-soft-access-open');
    error.hidden = true;
    error.classList.remove('is-visible');

    setTimeout(function () {
      input.focus();
    }, 20);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('fnd-soft-access-open');
    error.hidden = true;
    error.classList.remove('is-visible');
    input.value = '';
  }

  function showError() {
    error.hidden = false;
    error.classList.add('is-visible');
  }

  function hideError() {
    error.hidden = true;
    error.classList.remove('is-visible');
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  input.addEventListener('input', function () {
    hideError();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var entered = input.value.trim();
    var accessCode = (form.getAttribute('data-access-code') || '').trim();
    var accessUrl = form.getAttribute('data-access-url') || '';

    if (!entered) {
      showError();
      input.focus();
      return;
    }

    if (entered.toLowerCase() === accessCode.toLowerCase()) {
      hideError();

      if (accessUrl) {
        window.location.href = accessUrl;
      } else {
        closeModal();
      }

      return;
    }

    showError();
    input.focus();
    input.select();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}